<ng-container *ngFor="let bloque of page_data; let i = index" class="row" [ngSwitch]="bloque.tipoBloque">
  <!-- Publicidad de cabecera -->
  <ng-container *ngIf="i == 1 && publicidadCabecera?.enlace">
    <div class="row contenedor-publicidad contenedor-publicidad-header-movil">
      <div style="margin: 0 auto; width: 100%">
        <a *ngIf="publicidadCabecera?.enlace" [href]="publicidadCabecera?.enlace" target="_blank">
          <iframe *ngIf="publicidadCabecera?.esIframe == 1" [src]="publicidadCabecera?.urlIframe | safeResourceUrl" width="980" height="90" frameborder="0" scrolling="no"></iframe>
          <ng-container *ngIf="publicidadCabecera?.esIframe == 0">
            <img *ngIf="publicidadCabecera?.esVideo == 0" [src]="publicidadCabecera?.img" style="width: 100%" alt="ads" loading="lazy" width="100%" height="100%" />
            <video *ngIf="publicidadCabecera?.esVideo == 1" style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'">
              <source [src]="publicidadCabecera?.img" type="video/mp4" />
            </video>
          </ng-container>
        </a>
      </div>
    </div>
  </ng-container>

  <!-- Switch para los tipos de bloques -->
  <ng-container [ngSwitch]="bloque.tipoBloque">
    <ng-container *ngSwitchCase="'fila-una-columna'">
      <div class="row" [ngClass]="[getExtraClass(bloque.tipoBloque), bloque?.firstFila ? 'position-relative' : '']">
        <app-fila-una-columna [noticias]="bloque?.data" [idStart]="i" [lcp]="lcpBlocks().includes(i) ? false : true" [autorEmpresa]="autorEmpresa()" [showFecha]="showLadingDates"></app-fila-una-columna>
      </div>
      <div class="row">
        <div class="contenedor-directo" *ngIf="videosDirecto.length > 0">
          <h6 class="directo">
            <span>Directo</span><span>{{ autorEmpresa() }}</span>
          </h6>
          <h2 class="noticia-directo" *ngFor="let item of videosDirecto" [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">{{ item?.tituloVideo }}</h2>
        </div>
        <app-bloque-carta-director *ngIf="bloque?.firstFila"></app-bloque-carta-director>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'fila-dos-columnas'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)"><app-fila-dos-columnas [noticias]="bloque?.data" [idStart]="i" [lcp]="lcpBlocks().includes(i) ? false : true" [autorEmpresa]="autorEmpresa()" [showFecha]="showLadingDates"></app-fila-dos-columnas><br /></div>
    </ng-container>

    <ng-container *ngSwitchCase="'fila-tres-columnas'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)"><app-fila-tres-columnas [noticias]="bloque?.data" [idStart]="i" [lcp]="lcpBlocks().includes(i) ? false : true" [autorEmpresa]="autorEmpresa()" [showFecha]="showLadingDates"></app-fila-tres-columnas><br /></div>
    </ng-container>

    <ng-container *ngSwitchCase="'fila-cuatro-columnas'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-fila-cuatro-columnas [size]="240" [noticias]="bloque?.data" [idStart]="i" [lazy]="lcpBlocks().includes(i) ? false : true" [autorEmpresa]="autorEmpresa()" [showFecha]="showLadingDates"></app-fila-cuatro-columnas>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'dos-columnas-multifilas'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-dos-columnas-multifilas [noticias]="bloque?.data" [idStart]="i" [autorEmpresa]="autorEmpresa()" [showFecha]="showLadingDates"></app-dos-columnas-multifilas>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'bloque-divisor-publi'">
      <div class="row contenedor-publicidad contenedor-publicidad-header">
        <div id="DIVISOR_{{ bloque.publiNumber }}" class="publi publi-divisor" style="height: 150px"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'app-banner-app-mv'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-banner-app-mv *ngIf="!isWebView"></app-banner-app-mv>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'bloque-ultimos-blogs'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-bloque-ultimos-blogs></app-bloque-ultimos-blogs>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'bloque-patrocinados'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-bloque-patrocinados [idSeccion]="bloque.id_seccion" [idStart]="i"></app-bloque-patrocinados>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'bloque-separador'">
      <div class="row" [ngClass]="getExtraClass(bloque.tipoBloque)">
        <app-bloque-separador [contenido]="bloque?.data" [lcp]="lcpBlocks().includes(i) ? false : true"></app-bloque-separador>
      </div>
    </ng-container>
  </ng-container>

  <!-- Publicidad divisores móvil -->
  <ng-container *ngIf="bloque.tipoBloque !== 'app-banner-app-mv' && bloque.tipoBloque !== 'bloque-separador'">
    <div class="row publi publi-divisor-movil" id="publi-movil-{{ i }}">
      <ng-container *ngIf="publicidadDivisoresMovil[i]?.img">
        <a #enlaceRef href="{{ publicidadDivisoresMovil[i]?.enlace }}" target="_blank" (click)="abrirEnlace(enlaceRef)">
          <iframe *ngIf="publicidadDivisoresMovil[i]?.esIframe == 1" [src]="publicidadDivisoresMovil[i]?.urlIframe | safeResourceUrl" width="{{ publicidadDivisoresMovil[i]?.width }}" height="{{ publicidadDivisoresMovil[i]?.height }}" frameborder="0" scrolling="no"></iframe>
          <ng-container *ngIf="publicidadDivisoresMovil[i]?.esIframe == 0">
            <img *ngIf="publicidadDivisoresMovil[i]?.esVideo == 0" src="{{ publicidadDivisoresMovil[i]?.img }}" alt="{{ publicidadDivisoresMovil[i]?.titulo }}" loading="lazy" width="100%" height="100%" />
            <video *ngIf="publicidadDivisoresMovil[i]?.esVideo == 1" style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'">
              <source [src]="publicidadDivisoresMovil[i]?.img" type="video/mp4" />
            </video>
          </ng-container>
        </a>
        <iframe title="Publicidad" *ngIf="publicidadDivisoresMovil[i]?.tag_iframe" [src]="publicidadDivisoresMovil[i]?.tag_iframe | safeResourceUrl" width="1" height="1" marginwidth="0" marginheight="0" hspace="0" vspace="0" frameborder="0" scrolling="no" bordercolor="#000000"></iframe>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
<div #sentinel></div>
